import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { useUserDetails } from '../../store/slices/authSlice';
import { getAgentCallSummary, getAgentLoginSummary } from '../../store/slices/dashboardSlice';
import AgentCallSummary from './AgentCallSummary';
import AgentLoginSummary from './AgentLoginSummary';

const Dashboard = () => {
  const dispatch = useDispatch();
  const user = useUserDetails();
  const hasCdrPermission = Boolean(user?.cdr_permission);

  const agentCallSummaryGet = async () => {
    try {
      await dispatch(getAgentCallSummary()).unwrap();
    } catch (error) {
      console.log('error', error);
    }
  };

  const agentLoginSummaryGet = async () => {
    try {
      await dispatch(getAgentLoginSummary()).unwrap();
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    agentLoginSummaryGet();
  }, []);

  useEffect(() => {
    if (hasCdrPermission) agentCallSummaryGet();
  }, [hasCdrPermission]);

  return (
    <div>
      <Row>
        {hasCdrPermission && (
          <Col md="7">
            <AgentCallSummary />
          </Col>
        )}
        <Col md={hasCdrPermission ? '5' : '12'}>
          <AgentLoginSummary />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
